import { Box, Divider } from "@mui/material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useUser } from "../../../context";
import { useReadBudgetById } from "../../../hooks/react-query/use-read-budget-by-id";
import duplicateBudget from "../../../services/budget/duplicate-budget";
import { Layout } from "../layout";
import { DuplicateBudgetDialog } from "./duplicate-budget-dialog";
import { FirstStep, FirstStepData } from "./first-step/first-step";
import { StepData } from "./form-screen";
import * as s from "./styled-form-screen";

const DuplicateForm = () => {
    const [fullData, setFullData] = useState<StepData>({
        name: "",
        description: "",
        clientId: "",
        budgetTypeId: "",
        secondaryColor: "#00000",
        levelConfigs: [],
    });
    const [openDuplicateDialog, setOpenDuplicateDialog] =
        useState<boolean>(false);

    const navigate = useNavigate();

    const { user } = useUser();

    const { budgetId } = useParams();
    const id = budgetId ?? "";

    const { data: dataBudgetById } = useReadBudgetById({
        budgetId: id,
    });

    const submit = async (duplicateEstimation: boolean) => {
        const { data } = await duplicateBudget({
            body: {
                budgetTypeId: fullData.budgetTypeId!,
                clientId: fullData.clientId!,
                color: fullData.color!,
                description: fullData.description!,
                name: fullData.name!,
                secondaryColor: fullData.secondaryColor!,
                duplicateEstimation,
            },
            budgetId: budgetId!,
            userId: user.id_e,
        });

        navigate(`/financial/budget/modules/${data.id_e}`);
    };

    const nextStep = (projectData: StepData) => {
        setFullData(projectData);
        setOpenDuplicateDialog(true);
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "0.5rem",
                    width: "100%",
                }}
            >
                <s.Step className="active">
                    <div>1</div>
                    <span>Dados Iniciais</span>
                </s.Step>
                <Divider
                    sx={{
                        height: "0.0625rem",
                        width: "80%",
                    }}
                />
                <s.Step>
                    <div>2</div>
                    <span
                        style={{
                            lineBreak: "strict",
                        }}
                    >
                        Configurar Escopo
                    </span>
                </s.Step>
            </Box>
            {dataBudgetById && (
                <FirstStep
                    fullData={{
                        name: dataBudgetById.name,
                        description: dataBudgetById.description,
                        levelConfigs: dataBudgetById.LevelConfig,
                        budgetTypeId: dataBudgetById.type.id_e,
                        clientId: dataBudgetById.client.id_e,
                        color: dataBudgetById.color,
                        secondaryColor: dataBudgetById.secondary_color,
                    }}
                    nextStep={nextStep}
                ></FirstStep>
            )}
            {openDuplicateDialog && (
                <DuplicateBudgetDialog
                    open={openDuplicateDialog}
                    submit={submit}
                />
            )}
        </>
    );
};

export const BudgetDuplicate = () => {
    return <Layout children={DuplicateForm()} />;
};
